//-----validation forms
function validateEmail(email) {
    let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(email_string)) {
        return true;
    } else {
        return false;
    }

}
function validatePassword(pw) {
    return pw.length > 5;
    // return /[A-Z]/       .test(pw) &&
    //     /[a-z]/       .test(pw) &&
    //     /[0-9]/       .test(pw) &&
    //     /[^A-Za-z0-9]/.test(pw) &&
    //     pw.length > 4;

}
function validateName(name) {
    return (/[a-zA-Z]/.test(name) || /[а-яА-Я]/.test(name)) && name.length >= 3;
}
function validateTel(tel) {
    return (/[0-9]/.test(tel) && tel.length >= 10);
}
function formValidation() {
    let forms = document.querySelectorAll('.js-form-validation');
    if (!forms.length > 0) {
        return;
    }
    forms.forEach(function(form, i) {
        let input = form.querySelector('button[type="button"]:not(.toggle-password), button:not(.toggle-password)');
        if(input !== null){
            input.addEventListener('click', function(e) {
                e.preventDefault();
                let validInputs = input.closest('form').querySelectorAll('input:not([type="button"]):not([type="hidden"])');
                let valid = true;
                for(let i=0;i<validInputs.length;i++){
                    let validInput = checkValid(validInputs[i]);
                    if(validInput == false){
                        valid = false;
                        break;
                    }
                }
                if (valid == true) {
                    if(form.querySelector('.form-error') !== null) {
                        form.querySelector('.form-error').textContent = '';
                    }
                    if(form.id == 'contact_form' && form.classList.contains('footer-subscribe__form')){
                        submitKlaviyoFormFooter(form);
                    }else{
                        form.submit();
                    }

                } else {
                    console.log('not validation')
                    // form.querySelector('.form-error').textContent = window.error_fields.dont_valid_inputs;
                }
            })
        }

    });
}
function validateInputs(input) {
    if (input) {
        checkValid(input);
    } else {
        let inputs = document.querySelectorAll('.js-form-validation input:not([name="address[default]"]):not([type="submit"])');
        inputs.forEach(function(item) {
            item.addEventListener('change', function(e) {
                checkValid(item);
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', function () {
    formValidation();
    validateInputs();
})


function checkValid(item) {
    var validation = true;
    let field = item;
    let fieldValue = field.value.trim();
    if (fieldValue === '' && item.hasAttribute('required') && item.type != 'checkbox') {
        validation = false;
        field.classList.add('error');
        field.closest('.form-input-wrap, .input-wrap').classList.add('error');
        field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').textContent = window.error_fields.cant_be_blank;
    } else {
        if (item.getAttribute('name') == 'customer[email]' || item.getAttribute('name') == 'email' || item.getAttribute('name') == 'contact[email]' ) {
            let field = item;
            if (validateEmail(field.value) != true) {
                validation = false;
                field.classList.add('error');
                field.closest('.form-input-wrap, .input-wrap, .footer-subscribe__form-wrap').classList.add('error');
                field.closest('.footer-subscribe__form-wrap').nextElementSibling.textContent = window.error_fields.invalid_email;
                if(field.closest('.form-input-wrap, .input-wrap') !== null){
                    field.closest('.form-input-wrap, .input-wrap, .footer-subscribe__form-wrap').querySelector('.error:not(input)').textContent = window.error_fields.invalid_email;
                }
            } else {
                field.classList.remove('error');
                field.closest('.form-input-wrap, .input-wrap, .footer-subscribe__form-wrap').classList.remove('error');
            }
        } else
        if (item.hasAttribute('data-name')) {
            let field = item;
            if (validateName(field.value) != true) {
                validation = false;
                field.closest('.form-input-wrap, .input-wrap').classList.add('error');
                field.classList.add('error');

                field.closest('.form-input-wrap, .input-wrap').querySelector('span.error').innerHTML = window.error_fields.invalid_name;
            } else {
                field.classList.remove('error');
                field.closest('.form-input-wrap, .input-wrap').classList.remove('error');
                field.closest('.form-input-wrap, .input-wrap').querySelector('span.error').innerHTML = '';
            }
        } else
        if (item.getAttribute('type') == 'password') {
            let field = item;
            let pass = item.closest('form').querySelector('[name="customer[password]"]').value;
            let confirmPass = item.value;
            if (validatePassword(field.value) == false) {
                validation = false;
                field.classList.add('error');
                field.closest('.form-input-wrap, .input-wrap').classList.add('error');
                field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').textContent = window.error_fields.pass_be_five;
            }else if(item.hasAttribute('confirm')){
                if( pass !== confirmPass){
                    validation = false;
                    field.classList.add('error');
                    field.closest('.form-input-wrap, .input-wrap').classList.add('error');
                    field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').textContent = window.error_fields.pass_dont_match;
                }else{
                    field.classList.remove('error');
                    field.closest('.form-input-wrap, .input-wrap').classList.remove('error');
                }
            }else {
                field.classList.remove('error');
                field.closest('.form-input-wrap, .input-wrap').classList.remove('error');

            }
        } else
        if (item.getAttribute('type') == 'checkbox' && item.hasAttribute('required')) {
            let field = item;
            if (field.checked != true) {
                validation = false;
                field.closest('.checkbox-wrap, .form-checkbox-wrap').classList.add('error')
                field.classList.add('error');
            } else {
                field.closest('.checkbox-wrap, .form-checkbox-wrap').classList.remove('error')
                field.classList.remove('error');
            }
        } else
        if (item.getAttribute('type') == 'tel') {
            let field = item;
            if (validateTel(field.value) != true) {
                validation = false;
                field.classList.add('error');
                field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').innerHTML = window.error_fields.invalid_phone;
            } else {
                field.classList.remove('error');
                field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').innerHTML = '';
            }
        }else
        if (fieldValue !== '' && item.hasAttribute('required') && item.type != 'checkbox') {
            validation = true;
            field.classList.remove('error');
            field.closest('.form-input-wrap, .input-wrap').classList.remove('error');
            field.closest('.form-input-wrap, .input-wrap').querySelector('.error:not(input)').innerHTML = '';
        }
    }
    return validation;
}
//-----validation forms end

document.querySelector('.toggle-password').addEventListener('click', function () {
    const passwordInput = document.getElementById('pass_1');
    const isPasswordVisible = passwordInput.type === 'password';

    passwordInput.type = isPasswordVisible ? 'text' : 'password';

    // Зміна іконки, якщо потрібно
    this.textContent = isPasswordVisible ? '🙈' : '👁️'; // Можете замінити на потрібні іконки
});
